import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SmartAssignmentRow from './row';

import './assignment_preview.scss';

const CLASS_NAME = 'assignment-preview';

const AssignmentPreview = ({ editMode, onRemove, peopleIds, assignments, subText }) => {
  const assignmentIds = peopleIds || _.map(assignments, 'company_people_id');

  return (
    <div className={CLASS_NAME}>
      <div className={`${CLASS_NAME}__rows`}>
        {_.map(assignmentIds, personId => {
          const assignment = _.find(assignments, { company_people_id: personId });

          return (
            <SmartAssignmentRow
              assignment={assignment}
              editMode={editMode}
              key={personId}
              personId={personId}
              removePerson={onRemove}
            />
          );
        })}
      </div>

      {subText && <div className={`${CLASS_NAME}__subtext`}>{subText}</div>}
    </div>
  );
};

AssignmentPreview.propTypes = {
  assignments: PropTypes.array,
  editMode: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  peopleIds: PropTypes.array,
  subText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

AssignmentPreview.defaultProps = {
  editMode: true,
};

export default AssignmentPreview;
